import { useSignups } from "Signups/state";
import getIsSignupEligibleForFundIt from "Signups/utils/getIsSignupEligibleForFundIt";

// for the signup to be eligible, it needs to be a monetizable signup type, AND the network needs
// the `hasSignupPayments` flag (which checks for if feature is live and if network is US-based)
const useIsSignupEligibleForFundIt = () => {
  const [
    {
      currentSignupList: { signupListTypeID },
      hasSignupPayments,
    },
  ] = useSignups();
  return getIsSignupEligibleForFundIt(signupListTypeID) && hasSignupPayments;
};

export { useIsSignupEligibleForFundIt };
